import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
//import { IconDefinition, faExclamationTriangle, faTimesCircle, faInfoCircle, faCheckCircle } from '@fortawesome/fontawesome-pro';
import { isNullOrUndefined } from "util";

enum MessageTypes {
    "Success",
    "Info",
    "Error",
    "Warning",
    "Other"
}

export interface MessagePopupProps {
    showPopup: boolean; messageType: MessageTypes;
    popupTitle: string; okButtonText: string; children: any; onOkClick: any; enableOK?: boolean;
    showCancelButton?: boolean; cancelButtonText?: string; onCancelClick?: any
}
const MessagePopup = function (props: MessagePopupProps) {
    const [showMessagePopup, setShowMessagePopup] = useState(props.showPopup);
    const enableOK = !isNullOrUndefined(props.enableOK) ? props.enableOK : true; 

    useEffect(
        () => (
            setShowMessagePopup(props.showPopup)
        ),
        [props.showPopup]
    );

    const cancelClick = () => {

        setShowMessagePopup(false);

        if (props.onCancelClick) {
            props.onCancelClick();
        }
    }

  
/*    const getIcon = () => {
        var iconToReturn: IconDefinition;

        switch (props.messageType) {
            case MessageTypes.Success:
                iconToReturn = faCheckCircle;
                break;
            case MessageTypes.Error:
                iconToReturn = faTimesCircle;
                break;
            case MessageTypes.Warning:
                iconToReturn = faExclamationTriangle;
                break;
            case MessageTypes.Info:
                iconToReturn = faInfoCircle;
                break;
        }

        return iconToReturn;
    }*/

    return (
        <>
            <Modal show={showMessagePopup} backdrop="static" centered >
                <Modal.Header>
                    <Modal.Title>
                        {props.messageType !== MessageTypes.Other ? <> {props.popupTitle}</> : ""}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-left">
                    {props.children}
                </Modal.Body>
                <Modal.Footer className="d-contents justify-content-center justify-content-sm-end">
                    {props.showCancelButton && <Button className="btn-block-xs-only mx-2" variant="secondary" onClick={() => { cancelClick() }}>{props?.cancelButtonText ? props.cancelButtonText : "Cancel"}</Button>}
                    <Button className="btn-block-xs-only float-right" variant="primary" disabled={!enableOK} onClick={() => { props.onOkClick(); setShowMessagePopup(false); }}>{props.okButtonText}</Button>
                </Modal.Footer>
            </Modal>
        </>
    );

}

export { MessagePopup, MessageTypes };